

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const ReadAction = () => {
    const [searchTerm, setSearchTerm] = useState("");

    const notifications = [
        { id: 1, text: "18 days 6 hours, 26 min" },
        { id: 2, text: "Rohan Patil" },
        { id: 3, text: "Mukesh Kumar" },
    ];

    const filteredNotifications = notifications.filter(notification =>
        notification.text.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="h5 mb-0">Read Action</h5>
            </div>
            <div className="card-block">
                <div className="form-group position-relative">
                    <label className="form-label">Search</label>
                    <div className="input-group">
                        <input
                            type="search"
                            className="form-control input-me"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search..."
                        />
                        <span className="input-group-text">
                            <FontAwesomeIcon icon={faSearch} />
                        </span>
                    </div>
                </div>
                <div className="table-responsive mt-3">
                    <table className="table table-bordered table-hover table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Notification</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredNotifications.map(notification => (
                                <tr key={notification.id}>
                                    <td>{notification.id}</td>
                                    <td>{notification.text}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ReadAction;